package one.healthium.onboarding.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import one.healthium.domain.user.models.bindPlaceholderValues

@Composable
internal fun String.bindPlaceholderValues(userState: UserProfileUiModel): String {
    return remember(key1 = this, key2 = userState) {
        bindPlaceholderValues(this, userState)
    }
}

private fun bindPlaceholderValues(template: String, userState: UserProfileUiModel): String {
    return userState.model.bindPlaceholderValues(template, userState.isMetric)
}
